import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import userFeedbackAnalytics from '~/analytics/userFeedback/userFeedbackAnalytics'
import { useAppDispatch } from '~/redux/hooks'

import { openUserFeedbackModal } from '../redux/user-feedback'

interface FeedbackButtonProps {
  className?: string
  /** Stable identifier of the specific content being rated (e.g. Sanity _id, video srcKey, bootcamp level id). */
  contentId?: string
  /** Granular content kind, surfaced as content_subtype in PostHog (e.g. ContentType or the activity questionType). */
  contentSubtype?: string
  /** Human-readable label for the content, surfaced alongside contentId in PostHog. */
  contentTitle?: string
  product: string
  textClassName?: string
}

export default function FeedbackButton({
  product,
  contentId,
  contentSubtype,
  contentTitle,
  className,
  textClassName,
}: FeedbackButtonProps): React.ReactElement {
  const { t } = useTranslation('userFeedback')
  const dispatch = useAppDispatch()

  const handleFeedbackButtonClick = (): void => {
    dispatch(openUserFeedbackModal({ product, contentId, contentTitle, contentSubtype }))
    userFeedbackAnalytics.logUserFeedbackModalOpen()
  }
  return (
    <button
      className={`flex md:flex-col md:space-y-1 space-x-1 items-center ${className}`}
      onClick={handleFeedbackButtonClick}
    >
      <ResponsiveImage
        alt={t('imageAlt.feedbackButton')}
        height={40}
        imageClassName="h-6.5 w-7 md:h-9 md:w-10"
        srcKey="user-feedback/userFeedbackButton.svg"
        width={36}
      />
      <p className={`text-3 text-purple ${textClassName}`}>{t('feedbackButtonText')}</p>
    </button>
  )
}
